/* tslint:disable */
/* eslint-disable */
/**
 * story
 * storyのAPI
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CompanyStoriesLatest,
    CompanyStoriesLatestFromJSON,
    CompanyStoriesLatestFromJSONTyped,
    CompanyStoriesLatestToJSON,
} from './CompanyStoriesLatest';

/**
 * 
 * @export
 * @interface GetCompanyStoriesLatestResponse
 */
export interface GetCompanyStoriesLatestResponse {
    /**
     * 
     * @type {number}
     * @memberof GetCompanyStoriesLatestResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof GetCompanyStoriesLatestResponse
     */
    num: number;
    /**
     * 
     * @type {Array<CompanyStoriesLatest>}
     * @memberof GetCompanyStoriesLatestResponse
     */
    data: Array<CompanyStoriesLatest>;
}

export function GetCompanyStoriesLatestResponseFromJSON(json: any): GetCompanyStoriesLatestResponse {
    return GetCompanyStoriesLatestResponseFromJSONTyped(json, false);
}

export function GetCompanyStoriesLatestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCompanyStoriesLatestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total': json['total'],
        'num': json['num'],
        'data': ((json['data'] as Array<any>).map(CompanyStoriesLatestFromJSON)),
    };
}

export function GetCompanyStoriesLatestResponseToJSON(value?: GetCompanyStoriesLatestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total': value.total,
        'num': value.num,
        'data': ((value.data as Array<any>).map(CompanyStoriesLatestToJSON)),
    };
}

